import React from 'react';
import DataTableWithForm from '../components/DataTableWithForm';

const ProductPurchase = () => {
  const fetchUrl = '/zts/admin/v1.0/product/purchase/';
  const createUrl = '/zts/admin/v1.0/product/purchase/';
  const updateUrl = id => `/zts/admin/v1.0/product/purchase/${id}/`;
  const deleteUrl = id => `/zts/admin/v1.0/product/purchase/${id}/`;

  const columns = [
    { field: 'datetime', label: 'Date', format: val => val?.slice(0, 19).replace('T', ' ') },
    { field: 'name_display', label: 'Product' },
    { field: 'unit_price', label: 'Unit Price' },
    { field: 'quantity', label: 'Quantity' },
    { field: 'supplier_display', label: 'Supplier' },
  ];

  const formFields = [
    { name: 'name', label: 'Product ID' },
    { name: 'unit_price', label: 'Unit Price' },
    { name: 'quantity', label: 'Quantity' },
    { name: 'supplier', label: 'Supplier ID' }
  ];

  return (
    <DataTableWithForm
      title="Product Purchase"
      fetchUrl={fetchUrl}
      createUrl={createUrl}
      updateUrl={updateUrl}
      deleteUrl={deleteUrl}
      columns={columns}
      formFields={formFields}
    />
  );
};

export default ProductPurchase;

